import ContainerizationTestimonial from './containerizationTestimonial/ContainerizationTestimonial'
import ContainerizationService from './containerizationService/ContainerizationService'
import ContainerizationBuild from './containerizationBuild/ContainerizationBuild'
import ContainApproach from './containApproach/ContainApproach'
import ContainChoose from './containChoose/ContainChoose'
import ContainCapability from './containCapability/ContainCapability'
import ContainerizationWhat from './containerizationWhat/ContainerizationWhat'
import ContainBenefit from './containBenefit/ContainBenefit'
import ContainerizationHero from './containerizationHero/ContainerizationHero'

export default function Containerization() {
  return (
    <div>
        <ContainerizationHero/>
        <ContainerizationWhat/>
        <ContainCapability/>
        <ContainBenefit/>
        <ContainChoose/>
        <ContainApproach/>
        <ContainerizationBuild/>
        <ContainerizationTestimonial/>
        <ContainerizationService/>
    </div>
  )
}
